import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { X, Calculator, History, LayoutDashboard, Users, Package, FileText, Boxes } from 'lucide-react';

const userLinks = [
  { to: '/historial', label: 'Historial', icon: History },
];

const adminLinks = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/admin/usuarios', label: 'Usuarios', icon: Users },
  { to: '/admin/productos', label: 'Gabinetes', icon: Package },
  { to: '/admin/inventario', label: 'Inventario', icon: Boxes },
  { to: '/admin/cotizaciones', label: 'Todas las Cotizaciones', icon: FileText },
];

interface SidebarProps {
  onClose: () => void;
}

export function Sidebar({ onClose }: SidebarProps) {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
      isActive
        ? 'bg-blue-50 text-blue-700'
        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
    }`;

  const handleNuevaCotizacion = () => {
    navigate('/cotizacion', { state: { resetAt: Date.now() } });
    onClose();
  };

  const isCotizacionActive = location.pathname === '/cotizacion';

  return (
    <aside className="w-64 bg-white border-r border-gray-200 min-h-screen p-4">
      <div className="mb-8 px-4 flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-gray-900">LED Cotización</h1>
          <p className="text-xs text-gray-500 mt-1">Sistema de Cotización</p>
        </div>
        <button
          onClick={onClose}
          className="lg:hidden p-1 text-gray-400 hover:text-gray-600"
        >
          <X size={20} />
        </button>
      </div>

      <nav className="space-y-1">
        <p className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
          Cotización
        </p>
        <button
          onClick={handleNuevaCotizacion}
          className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
            isCotizacionActive
              ? 'bg-blue-50 text-blue-700'
              : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
          }`}
        >
          <Calculator size={18} />
          Nueva Cotización
        </button>
        {userLinks.map((link) => (
          <NavLink key={link.to} to={link.to} className={linkClass} onClick={onClose}>
            <link.icon size={18} />
            {link.label}
          </NavLink>
        ))}

        {isAdmin && (
          <>
            <div className="my-4 border-t border-gray-200" />
            <p className="px-4 text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2">
              Administración
            </p>
            {adminLinks.map((link) => (
              <NavLink key={link.to} to={link.to} className={linkClass} onClick={onClose}>
                <link.icon size={18} />
                {link.label}
              </NavLink>
            ))}
          </>
        )}
      </nav>
    </aside>
  );
}
